module.exports = __webpack_public_path__ + "media/images/views/home/home-section-intro-9ba2037336ba345fc100b10626bdaf60.png";